import type { GetAccountsParams } from '@repo/types';
import { useQuery } from '@tanstack/react-query';
import { getAccounts } from '../api/accountApi';

export const useAccounts = (params: GetAccountsParams) => {
  return useQuery({
    queryKey: ['accounts', params.page, params.limit, params.filterKey, params.filterValue],
    queryFn: () => getAccounts(params),
    staleTime: 5 * 60 * 1000, // 5분
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
